// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'img-container';
const slidableBreakpoint = '992px';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class LocationMap {
  constructor(el) {
    this.el = el;
    this.element = $(el);
    this.img = $(el).find('img');
    this.onlyPicture = $(el).find('.only-picture');
    this.content = $(el).find('.content-col__inside');

    this.mediaMatcher = window.matchMedia(`(max-width: ${slidableBreakpoint})`);

    if (!this.mediaMatcher.matches) {
      setTimeout(() => {
        this.imgContent(el);
      }, 1000);
    }

    this.mediaMatcher.addEventListener('change', (event) => {
      if (!event.matches) {
        setTimeout(() => {
          this.imgContent(el);
        }, 1000);
      }
    });
  }

  imgContent(el) {
    const sectionHeight = $(el).closest('.content-section').outerHeight();
    const newHeight = (this.img.outerHeight(true) + this.content.outerHeight(true));

    if (this.element.hasClass('content-col--layer') || this.element.closest('.poepplow-menu').length == 1  || this.element.closest('.content-section--top-service').length == 1 || this.element.closest('.is-trust').length == 1) {
      return;
    }

    $(el).css('--img-container-height', `${newHeight}px`);
    this.img.css('max-height', `${this.img.outerHeight(true)}px`);

    $(el).find('img').css('--img-height', `${sectionHeight}px`);
    $(el).closest('.content-section:not(.poepplow-menu)').addClass('content-section--img-container');

    const countElements = this.content.children().length;
    const buttonHeight = $(this.el).find('.wp-block-buttons').outerHeight(true);
    const buttonPos = (this.img.outerHeight() - buttonHeight - 128);

    if (countElements >= 2) {
      this.content.css('--content-height', `${this.img.outerHeight()}px`);
      $(this.el).find('.wp-block-buttons').addClass('wp-block-buttons--read-more')
    }

    $(this.el).find('.wp-block-buttons').css('--button-pos', `${buttonPos}px`);
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new LocationMap(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
